<template>
  <div class="homeIndex">
     <div class="homeIndex-header">
       <ul>
         <li>
           <span class="name">综合单位成本(元/斤)</span>
           <p class="count">{{this.allData.unitCost|decimal}}</p>
         </li>
          <li>
           <span class="name">总净收益(元)</span>
           <p class="count">{{(this.allData.totalRevenue-this.allData.totalExpense)|decimal}}</p>
         </li>
          <li>
           <span class="name">亩净效益(元)</span>
           <p class="count">{{this.allData.unitOfAreaRevenue|decimal}}</p>
         </li>
          <li>
           <span class="name">饲料用量(斤)</span>
           <p class="count">{{this.allData.totalFodder|decimal}}</p>
         </li>
          <li>
           <span class="name">饵料系数</span>
           <p class="count">{{this.allData.feedCoefficient|decimal}}</p>
         </li>
       </ul>
     </div>
     <div class="homeIndex-show">
        <div class="homeIndex-show-box">
          <p class="header">
            <img src="../../public/img/icon_pond_area.png" alt="">
            <span class="flex-one">塘口面积</span>
            <img class="check" src="../../public/img/check.png" alt="">
          </p>
       
          <div class="show">
              <span class="nodata" v-if="this.allData.pondAreas.length==0">
                暂无数据
              </span>
              <div ref="fishLine" id="fishLine" class="fishLine" style="padding-right:12px;height:260px;width:100%;"></div>
              <div class="show-text-1">
              <ul>
                <li v-for="(item,index) in this.allData.pondAreas" :key="index" v-show="index<6">
                    <p style="float:left;font-weight:bold;">
                      <span style="float:left;font-weight:bold;">{{item.value|decimal}}</span>
                      <span style="float:left;font-weight:bold;">&nbsp;亩</span>
                    </p>
                </li>
              </ul>
              </div>
          </div>
          <div class="number">
            <p>总面积：</p>
            <p>{{this.allData.totalPondArea | decimal}}亩</p>
          </div>
       </div>
       <div  class="homeIndex-show-box">
         <p class="header">
           <img src="../../public/img/icon_spend.png" alt="">
           <span>支出构成</span>
         </p>
         <div class="show">
          <span class="nodata" v-if="this.allData.expense.length==0">
            暂无数据
          </span>
          <div ref="pay" id="pay" class="pay" style="height:260px;width:100%;padding-right:10px;"></div>
           <div class="show-text">
             <ul>
               <li v-for="(item,index) in this.allData.expense" :key="index" v-if="index<6">
                  <!-- <span>|&nbsp;&nbsp;{{(item.rate)*100|decimal}}%</span> -->
                  <p style="margin-bottom:1px;font-weight:bold;margin-top:-1px;">￥&nbsp;{{item.value|decimal}}</p>
               </li>
             </ul>
           </div>
          </div>
          <div class="number">
            <p>总支出：</p>
            <p>{{this.allData.totalExpense | decimal}}元</p>
          </div>
       </div>
       <div  class="homeIndex-show-box">
         <p class="header">
           <img src="../../public/img/icon_income.png" alt="">
           <span>收益构成</span>
         </p>
         <div class="show">
          <span class="nodata" v-if="this.allData.revenueConstitutes.length==0">
            暂无数据
          </span>
          <div ref="inCome" id="inCome" class="inCome" style="height:260px;width:100%;padding-right:10px;"></div>
            <div class="show-text-2">
             <ul>
              <li v-for="(item,index) in this.allData.revenueConstitutes" :key="index" v-if="index<6">
                <p  style="margin-bottom:1px;font-weight:bold;">￥&nbsp;{{item.value|decimal}}</p>
               </li>
             </ul>
           </div>
          </div>
          <div class="number">
            <p>总收益：</p>
            <p>{{this.allData.totalRevenue | decimal}}元</p>
          </div>
       </div>
     </div>
     <div class="homeIndex-footer">
       <ul class="top">
          <li v-for="(item,index) in topList" :key="index" :class="{active: currentIndex === index}" @click="goTopList(index)">
            <img :src="'/img/' + item.src" alt="">
            <span>{{item.name}}</span>
          </li>
       </ul>
       <div class="content" v-if="currentIndex==0">
          <div ref="histogram"  class="histogram" style="height:320px;"></div>
       </div>
        <div 
          v-if="noData" 
          class="noData">
          <span>暂无数据</span>
          <img src="../../public/img/nodata.png" alt="" width="100px;height:100px">
        </div>
        <div class="content" v-if="currentIndex ==1">
          <div ref="histogramGoodLoss" class="histogramGoodLoss" style="height:320px;"></div>
       </div>
     </div>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../store";
import echarts from "echarts";
import { MessageBox, Message } from "element-ui";
export default {
  name: "homeIndex",
  data() {
    return {
      year: "",
      noData: false, //无数据状态
      unitY: "重量(斤)",
      topList: [
        { name: "损失分析", src: "icon_loss.png" },
        { name: "物资消耗", src: "icon_supplies.png" }
      ],
      currentIndex: 1,
      lossData: [],
      consumeData: [],
      formateList: [], //损失分析分组数据
      lossList: [], //物资耗用分组数据
      allData: {
        expense: [],
        feedCoefficient: [],
        pondAreas: [],
        revenueConstitutes: [],
        unitCost: "",
        totalRevenue: "",
        totalExpense: "",
        unitOfAreaRevenue: "",
        totalFodder: "",
        totalPondArea: ""
      }, //总数据
      legendPondData: [], //塘口面积图例
      seriesPondData: [], //塘口面积数据
      legendExpenseData: [], //支出图例
      seriesExpenseData: [], //支出面积数据
      legendRevenueData: [], //收益构成图例
      seriesRevenueData: [], //收益构成数据
      lossLegend: [], //损失图例
      lossXData: [], //损失X轴
      lossSeriesData: [], //损失数据
      consumeLegend: [], //物资消耗图例
      consumeXData: [], //物资消耗X轴
      consumeSeriesData: [] //物资消耗数据
    };
  },
  mounted() {
    let years = localStorage.getItem("homeYearIndex");
    if (years) {
      this.year = years;
    } else {
      //localStorage.setItem("homeYearIndex", 2020);
      this.year = new Date().getFullYear();
    }
    this.homeReportData(this.year);
    if (this.currentIndex == 0) {
      this.getLossReports(this.year);
    }
    if (this.currentIndex == 1) {
      this.$nextTick(() => {
        this.getConsumeReports(this.year);
      });
    }
    this.bus.$on("getYear", val => {
      // this.year = val;
      // this.$nextTick(() => {
      this.homeReportData(val);
      // });
      if (this.currentIndex == 0) {
        this.getLossReports(val);
      }
      if (this.currentIndex == 1) {
        this.$nextTick(() => {
          this.getConsumeReports(val);
        });
      }
    });
  },
  // watch: {
  //   year(val) {
  //     this.bus.$on("getYear", val => {
  //       this.year = val;
  //       this.homeReportData(val);
  //       this.getLossReports(val);
  //       this.$nextTick(() => {
  //         this.getConsumeReports(val);
  //       });
  //     });
  //   }
  // },
  computed: {
    ...mapState(["companyName"])
  },
  methods: {
    ...mapActions(["getCurCompany"]),
    ...mapActions(modules.homeReport, {
      GetCountReport: "GetCountReport",
      GetLossReport: "GetLossReport",
      GetConsumeReport: "GetConsumeReport"
    }),
    // 报表数据
    async homeReportData(year) {
      // this.$nextTick(() => {
      this.GetCountReport(year)
        .then(rsp => {
          if (rsp.status === 200) {
            console.log("respo", rsp.data);
            this.allData = rsp.data;
            var compare = function(property) {
              return function(obj1, obj2) {
                var value1 = obj1[property];
                var value2 = obj2[property];
                return value2 - value1; // 从大到小
              };
            };
            this.allData.pondAreas.sort(compare("value"));
            this.allData.expense.sort(compare("value"));
            this.allData.revenueConstitutes.sort(compare("value"));
            this.pondArea(this.allData.pondAreas, this.allData.totalPondArea); //塘口面积
            this.pay(this.allData.expense, this.allData.totalExpense); //支出构成
            this.inCome(
              this.allData.revenueConstitutes,
              this.allData.totalRevenue
            ); //收益构成
          }
        })
        .catch(err => {
          console.dir(err);
        });
      // });
    },
    //损失柱状图数据
    async getLossReports(year) {
      this.GetLossReport(year)
        .then(rsp => {
          if (rsp.status === 200) {
            if (rsp.data.length !== 0) {
              this.noData = false;
              this.unitY = "重量(斤)";
              this.lossData = rsp.data;
              // this.$nextTick(() => {
              this.histogram(this.lossData);
              // });
            } else {
              this.noData = true;
              this.unitY = "";
              this.lossData = [];
              // this.$nextTick(() => {
              this.histogram(this.lossData);
              // });
            }
          }
        })
        .catch(err => {
          console.log(787871);

          console.dir(err);
        });
    },
    //物资消耗柱状图数据
    async getConsumeReports(year) {
      // this.$nextTick(() => {
      this.GetConsumeReport(year)
        .then(rsp => {
          if (rsp.status === 200) {
            if (rsp.data.length !== 0) {
              this.noData = false;
              this.unitY = "重量(斤)";
              this.consumeData = rsp.data;
              this.histogramGoodLoss(this.consumeData);
            } else {
              this.noData = true;
              this.unitY = "";
              this.consumeData = [];
              this.histogramGoodLoss(this.consumeData);
            }
          }
        })
        .catch(err => {
          console.log(78787);

          console.dir(err);
        });
      // });
    },
    //塘口面积
    pondArea(ePondArea, totalPondArea) {
      let myChart = this.$echarts.init(this.$refs.fishLine);
      //塘口面积图例
      this.legendPondData = (function() {
        let res = [];
        let len = ePondArea.length;
        if (len >= 6) {
          len = 6;
        }
        for (let i = 0, size = len; i < size; i++) {
          res.push(ePondArea[i].name);
        }
        return res;
      })();
      //塘口面积数据
      this.seriesPondData = (function() {
        let res = [];
        let len = ePondArea.length;
        for (let i = 0, size = len; i < size; i++) {
          res.push({
            value: ePondArea[i].value,
            name: ePondArea[i].name
          });
        }
        return res;
      })();

      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} <br/>数值:{c} <br/> 所占比:{d}%"
        },
        avoidLabelOverlap: false,
        animation: false, //禁止浮动
        graphic: [
          // {
          //   type: "text",
          //   left: "67%",
          //   top: "86%",
          //   style: {
          //     text: totalPondArea | this.decimal,
          //     textAlign: "center",
          //     fill: "#000",
          //     font: "22px Microsoft YaHei"
          //   }
          // },
          // {
          //   type: "text",
          //   left: "29.5%",
          //   top: "47%",
          //   style: {
          //     text: "",
          //     fill: "#000",
          //     font: "16px Microsoft YaHei"
          //   }
          // }
        ],
        legend: {
          formatter: function(name) {
            return echarts.format.truncateText(
              name,
              100,
              "12px Microsoft Yahei",
              "..."
            );
          },
          tooltip: {
            trigger: "item",
            show: true
          },
          itemGap: 16,
          left: "57.3%",
          top: "5%",
          padding: 20,
          icon: "circle",
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            fontSize: 14,
            fontFamily: "Microsoft YaHei"
          },

          orient: "vertical",
          x: "right",
          data: this.legendPondData
        },
        color: [
          // "#c177ff",
          // "#fC619C",
          // "#4a89f1",
          // "#29c8a2",
          // "#f9ca5e",
          // "#08d2e2"
          "#4d92ff",
          "#45c18b",
          "#f7cd6c",
          "#8fe0e6",
          "#c289f2",
          "#f36ea0"
        ],
        series: [
          {
            name: "塘口面积",
            type: "pie",
            radius: [0, "50%"],
            center: ["35%", "45%"],
            label: {
              show: false
            },
            data: this.seriesPondData
          }
        ]
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    //支出构成
    pay(eExpense, totalExpense) {
      let myChart = this.$echarts.init(this.$refs.pay);
      //支出图例
      this.legendExpenseData = (function() {
        let res = [];
        let len = eExpense.length;
        if (len >= 6) {
          len = 6;
        }
        for (let i = 0, size = len; i < size; i++) {
          res.push(eExpense[i].name);
        }
        return res;
      })();
      //支出数据
      this.seriesExpenseData = (function() {
        let res = [];
        let len = eExpense.length;
        for (let i = 0, size = len; i < size; i++) {
          res.push({
            value: eExpense[i].value,
            name: eExpense[i].name
          });
        }
        return res;
      })();
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} <br/>数值:{c} <br/> 所占比:{d}%"
        },
        avoidLabelOverlap: false,
        animation: false, //禁止浮动
        graphic: [
          // {
          //   type: "text",
          //   left: "center",
          //   top: "bottom",
          //   style: {
          //     text: totalExpense | this.decimal,
          //     textAlign: "center",
          //     fill: "#000",
          //     font: "24px Microsoft YaHei"
          //   }
          // },
          // {
          //   type: "text",
          //   left: "29.5%",
          //   top: "47%",
          //   style: {
          //     text: "",
          //     textAlign: "center",
          //     fill: "#000",
          //     font: "16px Microsoft YaHei"
          //   }
          // }
        ],
        legend: {
          formatter: function(name) {
            return echarts.format.truncateText(
              name,
              100,
              "12px Microsoft Yahei",
              "..."
            );
          },
          tooltip: {
            trigger: "item",
            show: true
          },
          itemGap: 16,
          left: "57.3%",
          top: "5%",
          padding: 20,
          icon: "circle",
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            fontSize: 14,
            fontFamily: "Microsoft YaHei"
          },

          orient: "vertical",
          x: "right",
          data: this.legendExpenseData
        },
        color: [
          "#4d92ff",
          "#45c18b",
          "#f7cd6c",
          "#8fe0e6",
          "#c289f2",
          "#f36ea0"
        ],
        series: [
          {
            name: "支出构成",
            type: "pie",
            radius: [0, "50%"],
            center: ["35%", "45%"],
            label: {
              show: false
            },
            data: this.seriesExpenseData
          }
        ]
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    //收益构成
    inCome(eRevenue, totalRevenue) {
      let myChart = this.$echarts.init(this.$refs.inCome);
      //收益构成图例
      this.legendRevenueData = (function() {
        let res = [];
        let len = eRevenue.length;
        if (len >= 6) {
          len = 6;
        }
        for (let i = 0, size = len; i < size; i++) {
          res.push(eRevenue[i].name);
        }
        return res;
      })();
      //收益构成数据
      this.seriesRevenueData = (function() {
        let res = [];
        let len = eRevenue.length;
        for (let i = 0, size = len; i < size; i++) {
          res.push({
            value: eRevenue[i].value,
            name: eRevenue[i].name
          });
        }
        return res;
      })();
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} <br/>数值:{c} <br/> 所占比:{d}%"
        },
        avoidLabelOverlap: false,
        animation: false, //禁止浮动
        graphic: [
          // {
          //   type: "text",
          //   left: "center",
          //   top: "bottom",
          //   style: {
          //     text: totalRevenue | this.decimal,
          //     textAlign: "center",
          //     fill: "#000",
          //     font: "24px Microsoft YaHei"
          //   }
          // },
          // {
          //   type: "text",
          //   left: "center",
          //   top: "center",
          //   style: {
          //     text: "\r收益",
          //     textAlign: "center",
          //     fill: "#000",
          //     font: "16px Microsoft YaHei"
          //   }
          // }
        ],
        legend: {
          formatter: function(name) {
            return echarts.format.truncateText(
              name,
              70,
              "12px Microsoft Yahei",
              "..."
            );
          },
          tooltip: {
            trigger: "item",
            show: true
          },
          itemGap: 16,
          left: "57.3%",
          top: "5%",
          padding: 20,
          icon: "circle",
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            fontSize: 14,
            fontFamily: "Microsoft YaHei"
          },

          orient: "vertical",
          x: "right",
          data: this.legendRevenueData
        },
        color: [
          "#4d92ff",
          "#45c18b",
          "#f7cd6c",
          "#8fe0e6",
          "#c289f2",
          "#f36ea0"
        ],
        series: [
          {
            name: "收益构成",
            type: "pie",
            radius: [0, "50%"],
            center: ["35%", "45%"],
            label: {
              show: false
            },
            data: this.seriesRevenueData
          }
        ]
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },

    //损失分析
    histogram(es) {
      this.$nextTick(() => {
        let myChart = this.$echarts.init(this.$refs.histogram);
        let me = this;
        // 对接口返回数据进行 分组
        let dataList = (() => {
          let data = {};
          let list = es;
          for (let i = 0; i < list.length; i++) {
            if (!data[list[i].id]) {
              var arr = [];
              arr.push(list[i]);
              data[list[i].id] = arr;
            } else {
              data[list[i].id].push(list[i]);
            }
          }
          this.formateList = [];
          for (let i in data) {
            this.formateList.push(data[i]);
          }
          return this.formateList;
        })();
        //时间轴
        let as = (function() {
          let res = [];
          let len = es.length;
          for (let i = 0, size = len; i < size; i++) {
            res.push(es[i].month + "月份");
          }
          return res;
        })();
        this.lossXData = [];
        for (var i = 0; i < as.length; i++) {
          if (this.lossXData.indexOf(as[i]) == -1) {
            this.lossXData.push(as[i]);
          }
        }
        //图例数据
        let xx = (function() {
          let res = [];
          let len = dataList.length;
          for (let i = 0, size = len; i < size; i++) {
            res.push(dataList[i][0].name);
          }
          return res;
        })();
        //去重
        this.lossLegendData = (function() {
          for (var i = 0; i < xx.length - 1; i++) {
            for (var j = i + 1; j < xx.length; j++) {
              if (xx[i] == xx[j]) {
                xx.splice(j, 1);
                j--;
              }
            }
          }
          return xx;
        })();
        //渲染数据
        this.lossSeriesData = (() => {
          let res = [];
          dataList.forEach(category => {
            let data = [];
            category.forEach(item => {
              let unit = [
                me.lossXData.indexOf(item.month + "月份"),
                item.value
              ];
              data.push(unit);
            });
            let result = {
              name: category[0].name,
              type: "bar",
              barMaxWidth: 40,
              stack: "损失分析",
              data: data
            };
            res.push(result);
          });
          return res;
        })();
        myChart.clear();
        myChart.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: {
              lineStyle: {
                color: "rgba(255,255,255,0.0001)"
              }
            }
          },
          legend: {
            itemGap: 20,
            left: "center",
            bottom: 0,
            icon: "circle",
            itemWidth: 8,
            itemHeight: 8,
            textStyle: {
              fontSize: 14,
              fontFamily: "Microsoft YaHei"
            },
            x: "right",
            data: this.lossLegendData.slice(0, 8)
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [
            {
              type: "category",
              axisLine: {
                show: false
              },
              axisLabel: {
                color: "#999999"
              },
              axisTick: {
                //y轴刻度线
                show: false
              },
              data: this.lossXData
            }
          ],
          yAxis: [
            {
              axisLabel: {
                color: "#999999"
              },
              axisLine: {
                show: false
              },
              name: this.unitY,
              axisTick: {
                //y轴刻度线
                show: false
              },
              splitLine: {
                lineStyle: {
                  color: "rgba(234,234,234,1)"
                }
              },
              type: "value"
            }
          ],
          color: [
            "#3d5afe",
            "#fec400",
            "#6adaee",
            "#af24ff",
            "#34dfa5",
            "#f3d87d",
            "#f65c32",
            "#4cb2ff",
            "#725aeb",
            "#68e050",
            "#015aae",
            // "#ff5898",
            "#32b16c",
            "#d60077",
            "#e48056",
            "#fcb8d6",
            "#8715c3",
            "#dd2137",
            "#c57a00",
            "#d1c0a5"
          ],
          series: this.lossSeriesData
        });
        window.addEventListener("resize", function() {
          myChart.resize();
        });
      });
    },
    //物资消耗
    histogramGoodLoss(ess) {
      let myChart = this.$echarts.init(this.$refs.histogramGoodLoss);
      let me = this;
      // 对接口返回数据进行 分组
      let dataList = (() => {
        let data = {};
        let list = ess;
        for (let i = 0; i < list.length; i++) {
          if (!data[list[i].id]) {
            var arr = [];
            arr.push(list[i]);
            data[list[i].id] = arr;
          } else {
            data[list[i].id].push(list[i]);
          }
        }
        this.lossList = [];
        for (let i in data) {
          this.lossList.push(data[i]);
        }
        return this.lossList;
      })();
      //时间轴
      let as1 = (function() {
        let res = [];
        let len = ess.length;
        for (let i = 0, size = len; i < size; i++) {
          res.push(ess[i].month + "月份");
        }
        return res;
      })();
      //去重
      this.consumeXData = (function() {
        for (var i = 0; i < as1.length - 1; i++) {
          for (var j = i + 1; j < as1.length; j++) {
            if (as1[i] == as1[j]) {
              as1.splice(j, 1);
              j--;
            }
          }
        }
        return as1;
      })();

      //图例

      let x = (function() {
        let res = [];
        let len = dataList.length;
        for (let i = 0, size = len; i < size; i++) {
          res.push(dataList[i][0].name);
        }
        return res;
      })();
      //去重
      this.consumeLegend = (function() {
        for (var i = 0; i < x.length - 1; i++) {
          for (var j = i + 1; j < x.length; j++) {
            if (x[i] == x[j]) {
              x.splice(j, 1);
              j--;
            }
          }
        }
        return x;
      })();

      this.consumeSeriesData = (function() {
        let res = [];
        dataList.forEach(category => {
          let data = [];
          category.forEach(item => {
            let unit = [
              me.consumeXData.indexOf(item.month + "月份"),
              item.value
            ];
            data.push(unit);
          });

          let result = {
            name: category[0].name,
            type: "bar",
            barMaxWidth: 40,
            stack: "物资消耗",
            data: data
          };
          res.push(result);
        });
        return res;
      })();
      console.log(12, this.consumeSeriesData);

      myChart.clear();
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "rgba(255,255,255,0.0001)"
            }
          }
        },
        legend: {
          itemGap: 20,
          left: "center",
          bottom: 0,
          icon: "circle",
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            fontSize: 14,
            fontFamily: "Microsoft YaHei"
          },
          x: "right",
          data: this.consumeLegend.slice(0, 8)
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: false
            },
            axisTick: {
              //y轴刻度线
              show: false
            },
            data: this.consumeXData
          }
        ],
        yAxis: [
          {
            axisLine: {
              show: false
            },
            name: this.unitY,
            axisTick: {
              //y轴刻度线
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "rgba(234,234,234,1)"
              }
            },
            type: "value"
          }
        ],
        color: [
          // "#3d5afe",
          // "#fec400",
          // "#ff5898",
          // "#af24ff",
          // "#34dfa5",
          // "#f3d87d",
          // "#f65c32",
          // "#725aeb",
          // "#68e050",
          // "#6adaee",
          // "#32b16c",
          // "#d60077",
          // "#e48056",
          // "#015aae",
          // "#fcb8d6",
          // "#4cb2ff",
          // "#8715c3",
          // "#dd2137",
          // "#c57a00",
          // "#d1c0a5"
          "#3d5afe",
          "#fec400",
          "#6adaee",
          "#af24ff",
          "#34dfa5",
          "#f3d87d",
          "#f65c32",
          "#4cb2ff",
          "#725aeb",
          "#68e050",
          "#015aae",
          // "#ff5898",
          "#32b16c",
          "#d60077",
          "#e48056",
          "#fcb8d6",
          "#8715c3",
          "#dd2137",
          "#c57a00",
          "#d1c0a5"
        ],
        series: this.consumeSeriesData
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    goTopList(index) {
      let years = localStorage.getItem("homeYearIndex");
      if (years) {
        this.year = years;
      } else {
        //localStorage.setItem("homeYearIndex", 2020);
        this.year = new Date().getFullYear();
      }
      this.currentIndex = index;
      if (this.currentIndex == 0) {
        this.getLossReports(this.year);
      }
      if (this.currentIndex == 1) {
        this.$nextTick(() => {
          this.getConsumeReports(this.year);
        });
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.homeIndex
  padding: 12px 12px 30px 12px;
  .nodata
    position:absolute;
    color:#666;
    top:45%;
    left:45%;
  .homeIndex-header
    >ul
      display: flex;
      align-items: center;
      text-align: center;
      background:rgba(255,255,255,1);
      box-shadow:4px 0px 10px rgba(221,227,237,0.4);
      li
        width: 20%;
        color:rgba(102,102,102,1);
        font-size: 14px;
        border: 1px solid rgba(221,221,221,1);
        &:nth-child(n+1)
          border-right: none;
        &:last-child
          border-right: 1px solid rgba(221,221,221,1);
        .name
          line-height: 40px;
          font-family:MicrosoftYaHei;
          color:rgba(102,102,102,1);
        .count
          line-height: 70px;
          border-top: 1px solid rgba(221,221,221,1);
          font-size: 42px;
          font-family:DINMittelschrift;
          color:rgba(51,137,255,1);
  .homeIndex-show
    display: flex;
    margin-top: 13px;
    .homeIndex-show-box
      position relative
      min-width: 32.7%;
      height: 300px;
      margin-right: 12px;
      background:rgba(255,255,255,1);
      border:1px solid #DDDDDD;
      box-shadow:4px 0px 10px rgba(221,227,237,0.4);
      &:last-child
        margin-right: 0;
      .header
        height: 41px;
        line-height: 41px;
        font-size: 16px;
        color:rgba(102,102,102,1);
        background:rgba(247,247,247,1);
        position: relative;
        >img
          margin: 0 15px 0 22px;
          vertical-align: middle;
        .check {
          position: absolute;
          right: 7px;
          top: 13px;
          cursor: pointer;
        }
      .show
        display:flex;
        .show-text
          width:120px;
          margin-top:22px;
          margin-right:40px;
          height:160px; 
          position:relative;
         .show-text  ul li 
            height: 30px;
            line-height: 30px;
            color:#3d3d3d;
            width:120px;
            text-overflow:ellipsis;
            overflow: hidden;
            white-space: nowrap;
        .show-text-1
          width:120px;
          margin-top:22px;
          height:160px; 
        .show-text-1  ul li 
          height: 30px;
          line-height: 30px;
          color:#3d3d3d;
          width:120px;
          text-overflow:ellipsis;
          overflow: hidden;
          white-space: nowrap;
         .show-text-2
          width:150px;
          margin-top:22px;
          margin-right:40px;
          height:160px; 
          position:relative;
         .show-text-2  ul li 
            height: 30px;
            line-height: 30px;
            color:#3d3d3d;
            width:150px;
            text-overflow:ellipsis;
            overflow: hidden;
            white-space: nowrap;
        @media screen and (min-width: 1240px)and  (max-width:1810px) {
          .show-text-1{
            width:120px;
            margin-top:22px;
            // padding:0 20px 0 0px;
            height:160px; 
          }
          .show-text-1  ul li {
            height: 30px;
            line-height: 30px;
            color:#3d3d3d;
            width:120px;
            text-overflow:ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .show-text{
            width:90px;
            margin-top:22px;
            height:160px; 
            position:relative;
          }
           
          .show-text  ul li {
            height: 30px;
            line-height: 30px;
            margin-left:10px;
            color:#3d3d3d;
            // width:90px;
            text-overflow:ellipsis;
            overflow: hidden;
            white-space: nowrap;
         }
         .show-text-2{
            width:100px;
            margin-top:22px;
            margin-right:40px;
            height:160px; 
            position:relative;
         }
          
         .show-text-2  ul li {
            height: 30px;
            line-height: 30px;
            color:#3d3d3d;
            width:100px;
            text-overflow:ellipsis;
            overflow: hidden;
            white-space: nowrap;
         }
           
           
        } 
        @media screen and (min-width: 2000px) and (max-width:1920px){
          .show-text-1{
            width:120px;
            margin-top:22px;
            height:160px; 
          }
          .show-text-1  ul li {
            height: 30px;
            line-height: 30px;
            color:#3d3d3d;
            width:120px;
            text-overflow:ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        } 
      .number
        display:flex;
        justify-content:center;
        margin-top:-44px;
        >p:first-child
          font-size:20px;
          font-family:'Microsoft YaHei'
          color:#333;
        >p:last-child
           font-size:18px;
           padding-top:3px;
           color:#333;
  .homeIndex-footer
    position:relative;
    height: 380px;
    margin-top: 13px;
    background:rgba(255,255,255,1);
    border:1px solid #DDDDDD;
    box-shadow:4px 0px 10px rgba(221,227,237,0.4);
    .top
      display: flex;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      color:rgba(102,102,102,1);
      background:rgba(247,247,247,1);
      padding-left: 23px;
      >li
        min-width: 120px;
        border-bottom: 2px solid transparent;
        transition: all .25s linear;
        text-align: center;
        cursor: pointer;
        &.active
          border-color: #3389FF;
        >img
          margin-right: 13px;
          vertical-align: middle;
    .noData
      span 
        position: absolute;
        top: 65%;
        left: 50%;
        color: #666;
        font-size: 0.3rem;
      img
        position: absolute;
        top: 40%;
        left: 49%;

</style>
